// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import LiveStream from '@Organisms/LiveStream';
import RouteBuilder from '@Services/RouteBuilder';
import { matchPath } from 'react-router-dom';
import { baseUrl } from '../../../../index';

import './LiveFeed.scss';

interface LiveFeedProps {
    setCounter?: (num: number) => void;
}

const LiveFeed = ({ setCounter }: LiveFeedProps): ReactElement => {
    // remove AWS added path
    let urlWithoutBase = document.location.pathname;
    if (urlWithoutBase.includes(baseUrl)) {
        urlWithoutBase = urlWithoutBase.replace(baseUrl, '/');
    }

    const { caseId = '' } =
        matchPath<{ caseId: string }>(urlWithoutBase, {
            path: RouteBuilder.compute('cases.layout'),
            exact: false,
            strict: false,
        })?.params || {};

    return <LiveStream caseId={caseId} setCounter={setCounter} />;
};

export default LiveFeed;
